import TemplateRegistry from '../template/template-registry';

// NEW: color img swatch > forward to img-swatch
TemplateRegistry.templates['color-img-swatch'] = (option, config, onChange) => {
    return TemplateRegistry.templates['img-swatch'](option, config, onChange)
};